import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useAnalyticsEvent, useAnalyticsPageView } from '@chilecompra/react-kit/analytics'
import { Button, CheckBox, useCheckBox, useViewport } from '@chilecompra/react-kit/components'
import { isLocalEnv, REACT_APP_API_BASE_URL, REACT_APP_UNIQUE_PASS_SEED } from '../../config/settings/environment'
import { useCsrfToken } from '../../modules/hooks/security'
import {
  Conditions,
  DesktopNavigation,
  Hidden,
  Image,
  Instructions,
  MobileNavigation,
  Root,
  Section,
  TermsLink,
  Title
} from './RegisterWizardUniquePass.styles'

/**
 * The RegisterWizardUniquePass's container.
 */
const RegisterWizardUniquePass = props => {
  const { onChangeStep } = props
  const { value: checked, onChange: handleChange } = useCheckBox()
  const { size } = useViewport()
  const csrfToken = useCsrfToken(REACT_APP_UNIQUE_PASS_SEED)
  const claveUnicaUri = `${REACT_APP_API_BASE_URL}/v1/registro-civil/clave-unica/sso/authorize?csrf=${csrfToken}&aplicativo=inscripcion-proveedor`

  const handleBack = () => onChangeStep('welcome')

  const handleNext = useCallback(() => {
    if (!isLocalEnv) {
      window.location.href = claveUnicaUri
    } else {
      onChangeStep('personal-info')
    }
  }, [isLocalEnv, onChangeStep, claveUnicaUri])

  const disabledUniqueKey = !isLocalEnv && !checked

  useAnalyticsEvent({ action: 'Inicia registro por ClaveÚnica', category: 'registrar-usuario' })
  useAnalyticsPageView('/paso/1/clave_unica')

  return (
    <Root>
      <Section container>
        <Section item xs={12} md={6} maxWidth="546px">
          <Title>Comencemos</Title>
          <Instructions>
            Acepta los términos y condiciones y haz click en el botón de ClaveÚnica para poder acceder al portal del
            Registro Civil
          </Instructions>
          <Conditions>
            <CheckBox checked={checked} onChange={handleChange} color="primary" />
            Acepto{' '}
            <TermsLink
              href="https://www.chilecompra.cl/terminos-y-condiciones-de-uso/"
              rel="noopener noreferrer"
              target="_blank"
            >
              términos y condiciones de uso
            </TermsLink>
          </Conditions>
        </Section>
        <Hidden smDown>
          <Section item xs={12} sm={6} margin="-35px 0 0" padding="0 0 0 51px">
            <Image alt="Registro vía ClaveÚnica" src="/assets/img/steps/paso1.svg?h=e57104cc1427561c7d89c6004abefe06" />
          </Section>
        </Hidden>
      </Section>
      {!size.isTiny && (
        <Section container margin="52px 0 0" maxWidth="420px">
          <DesktopNavigation>
            <Button onClick={handleBack} type="button" variant="text" width="100%">
              Cancelar
            </Button>
            <Button
              color="primary"
              disabled={disabledUniqueKey}
              margin="0 0 0 30px"
              type="button"
              width="100%"
              onClick={handleNext}
            >
              <Image alt="Ir a ClaveÚnica" height="20px" src="/assets/img/logo-clave-unica.svg" />
            </Button>
          </DesktopNavigation>
        </Section>
      )}
      {size.isTiny && (
        <MobileNavigation>
          <Button onClick={handleBack} type="button" variant="text" width="168px">
            Cancelar
          </Button>
          <Button
            color="primary"
            disabled={disabledUniqueKey}
            margin="0 0 0 30px"
            type="button"
            width="168px"
            onClick={handleNext}
          >
            <Image alt="Ir a ClaveÚnica" height="20px" src="/assets/img/logo-clave-unica.svg" />
          </Button>
        </MobileNavigation>
      )}
    </Root>
  )
}

RegisterWizardUniquePass.defaultProps = {
  onChangeStep: () => undefined
}

RegisterWizardUniquePass.propTypes = {
  onChangeStep: PropTypes.func
}

export default RegisterWizardUniquePass
